module.exports = __webpack_public_path__ + "img/9791170280064.89f8b98d.jpg";